import { render, staticRenderFns } from "./learningCentreSidebar.vue?vue&type=template&id=53841d4a&scoped=true&"
import script from "./learningCentreSidebar.vue?vue&type=script&lang=js&"
export * from "./learningCentreSidebar.vue?vue&type=script&lang=js&"
import style0 from "./learningCentreSidebar.vue?vue&type=style&index=0&id=53841d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53841d4a",
  null
  
)

export default component.exports